import type { InvestmentSourceTypeEnum, LibraryItemTypeEnum } from 'venn-api';
import { LibraryItemType } from '../types';

export const BRAND_PROVIDED_ITEM_TYPE: LibraryItemTypeEnum = 'riskproProvided';

export const BRAND_INVESTMENT_SOURCE: InvestmentSourceTypeEnum = 'RISKPRO';

export const toBrandedItemType = (itemType: LibraryItemType): LibraryItemTypeEnum =>
  itemType === LibraryItemType.VENN_PROVIDED ? BRAND_PROVIDED_ITEM_TYPE : itemType;

export const fromBrandedItemType = (value: string): LibraryItemType =>
  value === BRAND_PROVIDED_ITEM_TYPE ? LibraryItemType.VENN_PROVIDED : (value as LibraryItemType);
